import { useCallback } from 'react'

import { AppId, RichAppIconData } from '@inno-tools/container-bridge'
import { useTopDockStore } from 'shared/stores/topDockStore'

interface UseRichAppIconObserverParams {
  appId?: AppId
}

export interface UseRichAppIconObserverReturn {
  richAppIconData: RichAppIconData | null
  setRichAppIconData: (data: RichAppIconData | null) => void
}

export const useRichAppIconObserver = ({
  appId
}: UseRichAppIconObserverParams): UseRichAppIconObserverReturn => {
  const richAppIconData = useTopDockStore(state =>
    state.getRichAppIconData(appId)
  )
  const storeSetRichAppIconData = useTopDockStore(
    state => state.setRichAppIconData
  )

  const setRichAppIconData = useCallback(
    (data: RichAppIconData | null) => {
      if (!appId) return
      storeSetRichAppIconData(appId, data)
    },
    [appId, storeSetRichAppIconData]
  )

  return {
    richAppIconData,
    setRichAppIconData
  }
}
